import React, { useState } from "react";
import {
    Box,
    Button,
    Typography,
    Select,
    MenuItem
} from "@mui/material";
import AddApiKey from "./ManagementPageComponents/AddApiKey";
export default function ApiKeySelector({
    apiKeys = [],
    selectedKeys = {},
    onChange,
    title = "Assign API Keys",
    defaultVendor =''
}) {
    const [showAdvanced, setShowAdvanced] = useState(false);
    const [showApiKeysModal, setShowApiKeysModal] = useState(false);

    // GROUP BY VENDOR
    let grouped = apiKeys.reduce((acc, key) => {
        const vendor = key.vendor || "Unknown";
        if (!acc[vendor]) acc[vendor] = [];
        acc[vendor].push(key);
        return acc;
    }, {});

    // ? If defaultVendor is set ? keep only that vendor
    if (defaultVendor && defaultVendor !== "") {
        grouped = {
            [defaultVendor]: grouped[defaultVendor] ?? []
        };
    }


    const handleVendorChange = (vendor, value) => {
        const finalValue = value === "__DEFAULT__" ? null : value;
        onChange({ ...selectedKeys, [vendor]: finalValue });
    };

    return (
        <>
            {!showApiKeysModal && (
                <Box sx={{ mt: 3 }}>
                    <Button
                        variant="outlined"
                        onClick={() => setShowAdvanced(!showAdvanced)}
                        sx={{ mb: 2 }}
                    >
                        {showAdvanced ? "Hide Advanced Options" : `Show ${title}`}
                    </Button>

                    {showAdvanced && (
                        <Box sx={{ mt: 2, p: 2, border: "1px solid #ddd", borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                {title}
                            </Typography>

                            {Object.keys(grouped).map((vendor) => (
                                <Box key={vendor} sx={{ mb: 3 }}>
                                    <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                                        {vendor} API Keys
                                    </Typography>

                                    <Select
                                        MenuProps={{
                                            disableAutoFocus: true,
                                            disableEnforceFocus: true,
                                            PaperProps: { tabIndex: undefined },
                                            MenuListProps: { autoFocusItem: false },
                                        }}
                                        SelectDisplayProps={{ tabIndex: -1 }}
                                        displayEmpty
                                        value={selectedKeys[vendor] ?? ""}
                                        onChange={(e) => handleVendorChange(vendor, e.target.value)}
                                        sx={{ minWidth: 300 }}
                                    >
                                        <MenuItem value="__DEFAULT__">
                                            <em>Use Sophona Tokens (default)</em>
                                        </MenuItem>

                                        {grouped[vendor].map((k) => (
                                            <MenuItem key={k.id} value={k.name}>
                                                {k.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                            ))}

                            <Button
                                variant="text"
                                size="small"
                                onClick={() => setShowApiKeysModal(true)}
                                sx={{
                                    textTransform: "none",
                                    color: "#6B46C1",
                                    fontWeight: 500,
                                    "&:hover": { color: "#553C9A" },
                                }}
                            >
                                + Add new API key
                            </Button>
                        </Box>
                    )}
                </Box>
            )}

            {showApiKeysModal && (
                <AddApiKey handleClose={() => setShowApiKeysModal(false)} defaultVendor={defaultVendor} />
            )}
        </>
    );
}
